<div class="modal-header">
  <h3 class="modal-title">Add/Update Scrubbing</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="toggleMinimise()"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  <div class="row" style="margin: 20px">
    <div class="col-md-12 input-group">
      <label class="" for="label">Label</label>
      <input type="text" id="label" class="form-control"
             [(ngModel)]="label"
             placeholder="Enter the label" required>
    </div>
  </div>
  <div class="row" style="margin: 20px">
    <div class="col-md-12 input-group">
      <label class="" for="searchKey">Search Key</label>
      <input type="text" id="searchKey" class="form-control"
             [(ngModel)]="searchKey"
             placeholder="Enter the search key to replace" required>
    </div>
  </div>
  <div class="row" style="margin: 20px">
    <div class="col-md-12 input-group">
      <label for="replaceWith" class="">Replace with</label>
      <input type="text" id="replaceWith" class="form-control"
             [(ngModel)]="replaceWith"
             placeholder="Enter the value to replace the search key with">
    </div>
  </div>
</div>
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="(!label || !searchKey) || loading" (click)="save()">
    @if (loading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
